import apiFetch from '@wordpress/api-fetch';

export const dismissSetupWizardAPI = async ( dismiss = 'yes' ) => {
	return await apiFetch( {
		path: 'getting-started/v1/dismiss-setup-wizard',
		method: 'POST',
		data: { dismiss },
		headers: {
			'X-WP-Nonce': gettingStartedVars.rest_api_nonce,
		},
	} );
};

const API = {
	dismissSetupWizard: dismissSetupWizardAPI,
};

export default API;
